import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = [
    "EPIDEMIOLOGIST & BIOSTATISTICIAN",
    "EVIDENCE-BASED RESEARCH",
    "DISEASE SURVEILLANCE",
    "R · STATISTICAL ANALYSIS",
    "NAIROBI, KENYA",
    "OPEN TO ROLES WORLDWIDE",
  ];
  return (
    <div className="py-4 md:py-5 border-y border-[#d2d5ce] relative z-10 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t) => (
          <span key={t} className="flex items-center">
            <span className="font-serif-display font-[500] text-[#16324f] text-lg md:text-2xl px-6 tracking-tight uppercase">
              {t}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#b5423a]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
